import WagesParamsForm from './WagesParamsForm';

export default WagesParamsForm;